module.exports = __webpack_public_path__ + "assets/94098a459c511472a8090ebf4e02ce8c.png";